import { blue, ChipStatusText, green, grey, purple } from "@flat-ui";
import { AnnotationStatus } from "@faro-lotv/ielement-types";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Different colors of the status */

/**
 * Contains different colors for (icon, icon-background, icon-border) based on the status.
 *
 * Each status is a self-contained tinted pill - it brings its own background, so it stays legible
 * under either colour scheme without following it. Re-valuing the set needs the `surfaces/*` and
 * per-intent `_states/*` token groups that flat-ui still defers, so it is left whole here rather
 * than converting only the two neutral rows and leaving the map inconsistent.
 */
export const markupStatusColor = {
  [AnnotationStatus.Open]: {
    icon: grey[700],
    iconBackground: grey[100],
    iconBorder: grey[300]
  },
  [AnnotationStatus.InProgress]: {
    icon: PALETTE_VARS.primary.main,
    iconBackground: blue[50],
    iconBorder: blue[100]
  },
  [AnnotationStatus.ToReview]: {
    icon: purple[500],
    iconBackground: purple[50],
    iconBorder: purple[100]
  },
  [AnnotationStatus.Resolved]: {
    icon: green[700],
    iconBackground: green[50],
    iconBorder: green[100]
  },
  [AnnotationStatus.Unclassified]: {
    icon: grey[500],
    iconBackground: grey[0],
    iconBorder: grey[300]
  }
};

/** All the dropdown options for markup status */

/** List of available options to use for the DropDownMarkupField's value property */
export const STATUS_OPTIONS = Object.values(AnnotationStatus).map(status => ({
  key: status,
  value: status,
  label: ChipStatusText[status]
}));